export default __webpack_public_path__ + "static/media/AvenirNextCyr-Regular.1f3e188c.woff";